import React, { useState } from 'react';
import { Service } from '@yleisradio/areena-types';

type Value = {
  service: Service;
  setService: (service: Service) => void;
  query: string;
  setQuery: (query: string) => void;
};

const errorNotInitializedMsg = 'Search context not initialized';

const SearchContext = React.createContext<Value>({
  service: 'tv',
  setService: () => {
    throw new Error(errorNotInitializedMsg);
  },
  query: '',
  setQuery: () => {
    throw new Error(errorNotInitializedMsg);
  },
});

export const SearchContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [service, setService] = useState<Service>('tv');
  const [query, setQuery] = useState('');

  return (
    <SearchContext.Provider value={{ service, setService, query, setQuery }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearchContext = () => {
  return React.useContext(SearchContext);
};

export default SearchContext;
